import api from './api';
import router from '@/router'

const interceptors = () => {
  api.interceptors.request.use(
    (config) => {
      const accessToken = localStorage.getItem('access');
      if (accessToken) config.headers.Authorization = 'Bearer ' + accessToken;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  api.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalConfig = error.config;
      const refreshToken = localStorage.getItem('refresh');

      if (
        refreshToken &&
        error['response'] &&
        error.response.status === 401 &&
        !originalConfig._retry &&
        !error.config.url.includes('/tokens')
      ) {
        originalConfig._retry = true;

        try {
          const res = await api.post('/tokens', {
            refresh: refreshToken,
          });

          if (res.status === 200) {
            localStorage.setItem('access', res.data.access);
            return api(originalConfig);
          }
        } catch (_error) {
          return Promise.reject(_error);
        }
      } else {
        if (error.config && error.config.url.includes('/tokens')) {
          localStorage.removeItem('access');
          localStorage.removeItem('refresh');
          router.push('/login');
        }
      }
      return Promise.reject(error);
    }
  );
  
};

export default interceptors;
